// Story stages — one per stage-boss. The interstitial card shown when entering
// a stage carries the narrative (origin → discovery → corrupted ally → Zero Day),
// per LORE.md. The prototype reveal is saved for Zero Day's defeat.
export interface StageInfo {
  name: string;
  lines: string[];
}

export const STAGES: StageInfo[] = [
  {
    name: "STAGE I — SERVER FARM",
    lines: [
      "Millions of nodes keep the world talking.",
      "Then a corruption appeared, and the nodes began to fail.",
      "You are PCKT — the last recovery agent still online. Restore the sensors.",
    ],
  },
  {
    name: "STAGE II — SATELLITE RELAY",
    lines: [
      "The Server Farm holds. But the corruption is spreading.",
      "New strains surface — faster, stranger than the last.",
      "Keep the signal alive.",
    ],
  },
  {
    name: "STAGE III — FIBER BACKBONE",
    lines: [
      "These aren't random attacks. They're coordinated.",
      "The corruption is learning. Adapting to you.",
      "Something is directing it from deeper in the Grid.",
    ],
  },
  {
    name: "STAGE IV — POWER GRID",
    lines: [
      "The Firewall — the network's defenders — have gone silent.",
      "No response on any channel.",
      "You're on your own now.",
    ],
  },
  {
    name: "STAGE V — CLOUD CLUSTER",
    lines: [
      "One Firewall agent is still transmitting — but corrupted.",
      "Their systems see PCKT as the threat now.",
      "Free them from the corruption. It's the only way through.",
    ],
  },
  {
    name: "STAGE VI — DEEP CORE",
    lines: [
      "Known threats: eliminated. Unknown threat detected.",
      "Designation: ZERO DAY. No countermeasure exists.",
      "Adapt.",
    ],
  },
];

export function stageInfo(index: number): StageInfo | null {
  return index >= 0 && index < STAGES.length ? STAGES[index] : null;
}
